<template>
  <div class="tippop" ref="pop" :style="{display: isshow}">
    <div class="tippopbox">
      <h2>恭喜你，已是我馆志愿者</h2>
      <span @click.stop="confirm">完成</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tipcommon',
  props: ['popIsshow'],
  data () {
    return {
      timers: null,
      isshow: 'none'
    }
  },
  watch: {
    popIsshow (val) {
      this.isshow = val
    }
  },
  methods: {
    confirm () {
      this.isshow = 'none'
      this.timers = setInterval(() => {
        this.$router.push({path: '/volunteer'})
      }, 300)
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
    this.timers = null
  }
}
</script>

<style lang="scss">
  .tippop{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0,0,0,0.4);
    .tippopbox{
      width: 60%;
      height: 140px;
      position: fixed;
      top: 50%;
      left: 50%;
      margin: -70px 0 0 -30%;
      background: #fff;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      overflow: hidden;
      padding: 40px 20px 0;
      h2{
        font-size: 14px;
        text-align: center;
      }
      span{
        display: block;
        position: absolute;
        width: 60%;
        height: 36px;
        line-height: 36px;
        background: #a11b00;
        text-align: center;
        bottom: 15px;
        left: 50%;
        margin-left: -30%;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        color:#fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/common/tipcommon.vue